var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _ellipse, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocumentMedal = function SvgDocumentMedal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M26.9952 22.2837C26.9952 18.97 29.6815 16.2837 32.9952 16.2837H94.1643C97.478 16.2837 100.164 18.97 100.164 22.2837V111.718H32.9952C29.6815 111.718 26.9952 109.031 26.9952 105.718V22.2837Z",
    fill: "url(#paint0_linear_2215_10497)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.161 64.7933H105.295C108.609 64.7933 111.295 67.4796 111.295 70.7933V105.715C111.295 109.029 108.609 111.715 105.295 111.715H100.161V64.7933Z",
    fill: "url(#paint1_linear_2215_10497)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7445,
    y: 31.3957,
    width: 47.7189,
    height: 3.97641,
    rx: 1.9882,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7445,
    y: 40.9352,
    width: 31.0173,
    height: 3.97641,
    rx: 1.9882,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7445,
    y: 50.48,
    width: 55.6721,
    height: 3.97641,
    rx: 1.9882,
    fill: "#E0E0E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7445,
    y: 60.0276,
    width: 31.0173,
    height: 3.97641,
    rx: 1.9882,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7445,
    y: 76.7211,
    width: 18.2923,
    height: 3.97641,
    rx: 1.9882,
    fill: "#E0E0E0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7445,
    y: 84.6765,
    width: 23.8595,
    height: 3.97641,
    rx: 1.9882,
    fill: "#E0E0E0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.4648,
    cy: 82.291,
    rx: 7.95315,
    ry: 7.95281,
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2593 86.8778C78.3761 86.5406 78.7442 86.362 79.0814 86.4788L83.2358 87.9182C83.573 88.035 83.7517 88.4031 83.6348 88.7403L80.7022 97.2039C80.5008 97.7851 79.678 97.7828 79.4799 97.2004L78.862 95.3839C78.7264 94.9852 78.2517 94.8207 77.8984 95.0501L76.2891 96.0949C75.7732 96.4299 75.1253 95.9226 75.3267 95.3414L78.2593 86.8778Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 89.2369C82.2643 88.9128 82.4058 88.5289 82.7298 88.3794L86.722 86.5373C87.046 86.3878 87.4299 86.5293 87.5795 86.8533L91.3326 94.9864C91.5903 95.5449 90.9956 96.1136 90.4491 95.8311L88.7446 94.9501C88.3705 94.7567 87.9143 94.9672 87.8186 95.3774L87.383 97.2459C87.2433 97.845 86.4247 97.9285 86.1669 97.3699L82.4138 89.2369Z",
    fill: "#E0E0E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2215_10497",
    x1: 64.0549,
    y1: 16.2837,
    x2: 153.918,
    y2: 253.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2215_10497",
    x1: 109.903,
    y1: 70.7579,
    x2: 90.3642,
    y2: 73.9493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentMedal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "document-medal.931b635233a9804abdb023a74badef52.svg";